/* ---- USED FOR LOGIN, SIGNUP, RESET PASSWORD base container ---- */
import { motion, AnimatePresence } from "framer-motion";
import { FiAlertTriangle } from "react-icons/fi";

import Logo from "assets/images/logo.svg";
import { Button } from "shared/components";

import styles from "./auth-form.module.scss";
import { Checkbox } from "antd";
import { useRouteMatch } from "react-router";
import { useTranslation } from "react-i18next";

export default function AuthForm({
  children,
  footer,
  handleSubmit,
  onSubmit,
  formStatus,
  buttonLabel = "submit",
  title,
  subTitle,
  inlineStyles,
  isDisabled,
  isProcessing,
}) {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <div className={styles.container}>
      <div className="flex flex-col">
        <form
          className={styles.form}
          style={{ ...inlineStyles }} // To hanle wider signup form
          onSubmit={onSubmit}
        >
          <div className={styles.logoContainer}>
            <img src={Logo} className={styles.logo} alt="MeeM text logo" />
            {path.includes("onboard") && (
              <div className="imp-info">
                {/* <span style={{ color: "red", fontSize: 20 }}>*</span> */}
                {/* <p>{t("Required to fill")}</p> */}
                <Checkbox checked={true} />
                <p style={{ display: "flex", alignItems: "center" }}>
                  {t("Click to set privacy to private")}
                  {/* <MdHttps size={12} style={{ marginLeft: "1px" }} /> */}
                </p>
              </div>
            )}
          </div>
          {/* <h1 className={styles.title}>{t(`${title}`)}</h1> */}
          <h1 className={styles.title}>{t(title)}</h1>
          {subTitle && <p className={styles.subTitle}>{t(subTitle)}</p>}

          {children}
          <AnimatePresence>
            {formStatus.status === "ERROR" && (
              <motion.div
                className={styles.errorMsg}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              >
                <motion.p style={{ marginRight: "4px" }}>
                  <FiAlertTriangle className={styles.errorIcon} />
                </motion.p>
                <motion.p>{formStatus?.statusMsg}</motion.p>
              </motion.div>
            )}
          </AnimatePresence>

          <div className={styles.formBtn}>
            <Button
              tabIndex="2"
              type="submit"
              classes={[styles.submitButton]}
              disabled={isDisabled || formStatus.status === "PROCESSING"}
              isProcessing={isProcessing || formStatus.status === "PROCESSING"}
            >
              {t(buttonLabel)}
            </Button>
          </div>
        </form>
        <div className={styles.signup}>{footer}</div>
      </div>
    </div>
  );
}
